import { UserRoleEnum } from '../interfaces/user.interface';

export const isUserRole = (role: UserRoleEnum): boolean => {
  return ![UserRoleEnum.admin, UserRoleEnum.superAdmin, UserRoleEnum.customerService].includes(role);
}